import { useState, useCallback } from 'react';
import styled from 'styled-components';
import { useInterval, useTimeout } from 'usehooks-ts';
import { isError } from '@belong/api';
import ChatAPI from '../api';
import { LIVE_CHAT_TEST_IDS } from '../lib/testIds';

const TextWrapper = styled.div`
  text-align: center;
  margin-top: 16px;
`;

const useQueuePosition = contactId => {
  const [message, setMessage] = useState<string>();
  const getPosition = useCallback(() => {
    if (contactId) {
      ChatAPI.getQueuePosition(contactId)
        .then(result => {
          const { response, body } = result;
          if (!response.ok || isError(body)) {
            throw new Error();
          } else {
            setMessage(body?.message);
          }
        })
        .catch(() => setMessage(undefined));
    }
  }, [contactId]);

  // small delay for initial query, to give back-end a moment to begin queueing process,
  // then constant polling
  useTimeout(getPosition, 5 * 1000);
  useInterval(getPosition, 30 * 1000);

  return message;
};

type ChatQueuePositionProps = {
  contactId?: string;
};

export const ChatQueuePosition: React.FC<ChatQueuePositionProps> = ({ contactId }) => {
  const message = useQueuePosition(contactId);

  return <div data-testid={LIVE_CHAT_TEST_IDS.QUEUE_POSITION}>{message && <TextWrapper>{message}</TextWrapper>}</div>;
};

ChatQueuePosition.displayName = 'ChatQueuePosition';
